import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { ModeFormValues } from "src/models/Mode.model";
import Mode from "../Layouts/ModeForm";
import {
  useGetModeByIdQuery,
  useUpdateModeByIdMutation,
} from "src/services/ModeServices";
import { showToast } from "src/utils/showToaster";
import { CircularProgress } from "@mui/material";

type Props = {
  onClose: () => void;
  selectedModeId: string;
};

const EditModeWrapper = ({ onClose, selectedModeId }: Props) => {
  // Form Initial Values
  const [items, setItems] = useState<any>({});

  const { isLoading, isFetching, data } = useGetModeByIdQuery(selectedModeId);
  const [updateModeById] = useUpdateModeByIdMutation();

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setItems(data?.data);
    }
  }, [isLoading, isFetching, data]);

  const initialValues: ModeFormValues = {
    modeName: items?.modeName || "",
    description: items?.description || "",
    bookType: items?.bookType || "",
    modeCode: items?.modeCode || "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    modeName: string().required("Please enter mode name"),
    modeCode: string().required("Please enter mode code"),
  });

  // Handle Submit
  const handleSubmit = (
    values: ModeFormValues,
    { setSubmitting, resetForm }: FormikHelpers<ModeFormValues>
  ) => {
    // const { modeCode, ...rest } = values;
    // const formattedValues = {
    //   ...rest
    // }
    const payload = {
      modeName: values.modeName,
      description: values.description,
      bookType: values.bookType,
      modeCode: values.modeCode,
    };
    updateModeById({ id: selectedModeId, body: payload }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            {(isLoading || isFetching) && (
              <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
                <CircularProgress />
              </div>
            )}
            <Mode formikProps={formikProps} onClose={onClose} formType="EDIT" />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default EditModeWrapper;
